import { langHasValue } from '../../utils/langText';

// check if the form can be submitted
const checkIfSubmittable = (formData, languages) => {
  if (!formData) return false;

  const unValid = Object.keys(formData).some((i) => {
    if (!formData[i].mandatory) return false;

    if (formData[i].type == 'MULTISELECT') {
      if (!formData[i]?.value) return true;

      return formData[i]?.value?.length < 1;
    } else if (typeof formData[i]?.value == 'object') {
      delete formData[i]?.value?.id;
      delete formData[i]?.value?.__typename;

      const hasVal = langHasValue(formData[i].value, languages);

      if (!hasVal) {
        return true;
      }
    } else if (formData[i].value === 0) {
      return false;
    } else if (formData[i].value && formData[i].value.id == '') {
      return true;
    } else if (!formData[i].value || formData[i].value.length < 1) {
      return true;
    }
  });

  return !unValid;
};

export default checkIfSubmittable;
